var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "date-select" }, [
    _c(
      "a",
      {
        staticClass: "dates custom-select bg-transparent",
        attrs: { href: "javascript:void(0)" },
        on: {
          click: function($event) {
            _vm.showPanel = !_vm.showPanel
          }
        }
      },
      [
        _vm._v(
          _vm._s(_vm.value ? _vm.smallDateFormatter(_vm.value) : "GG/MM/YYYY")
        )
      ]
    ),
    _vm._v(" "),
    _vm.showPanel
      ? _c(
          "div",
          {
            staticClass: "position-absolute p-1 border rounded bg-white",
            staticStyle: {
              "z-index": "10",
              width: "225px",
              "max-height": "130px",
              overflow: "auto"
            },
            on: {
              click: function($event) {
                _vm.showPanel = false
              }
            }
          },
          _vm._l(_vm.dates, function(item, index) {
            return _c(
              "button",
              {
                key: index,
                staticClass:
                  "rounded-0 m-1 px-1 btn btn-outline-primary btn-sm nowrap",
                staticStyle: { width: "45px" },
                on: {
                  click: function($event) {
                    return _vm.onSelect(item)
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.smallerDateFormatter(item)) +
                    "\n        "
                )
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-193d9998", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-193d9998","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/DateSelect.vue
// module id = null
// module chunks = 